import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { Label } from "../ui/Label";

interface Props {
  name: string;
  placeholder: string;
  type: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  register?: object; // To pass `react-hook-form`'s register prop
  error?: string; // Error message for the input field
  isIconAllow?: boolean;
  className?: string;
  isLabel?: boolean;
  label?: string;
}

const CommonInput: React.FC<Props> = ({
  name,
  placeholder,
  type,
  value,
  onChange,
  register,
  error,
  isIconAllow = false,
  className,
  isLabel = false,
  label,
}) => {
  {
  }
  return (
    <div className="flex flex-col w-auto">
      {isLabel && <Label className="mb-2">{label}</Label>}
      <div
        className={`flex items-center min-w-[14rem] gap-2 pl-2 h-10 rounded-md border ${
          error
            ? "border-red-500 focus-within:ring-red-500"
            : "border-primary focus-within:ring-0 focus-within:ring-slate-50"
        } focus-within:outline-none focus-within:ring-2`}
      >
        {isIconAllow && (
          <FontAwesomeIcon icon={faEnvelope} className="text-primary size-6" />
        )}
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...register}
          className={`w-full h-full outline-none bg-transparent text-white  placeholder:text-md placeholder:text-slate-400 ${className}`}
        />
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default CommonInput;
